import { ControllerRelationshipView} from "./controller-relationship-view";

export class ControllerView {

  private returnFieldValues: boolean = false;
  private relationships: any[] = [];

  contructor() {}

  requestFields(returnFieldValues: boolean) {
    this.returnFieldValues = returnFieldValues;
  }

  requestRelationship(relationshipName: string, returnFieldValues: boolean, returnAvailableValues: boolean, displayFields: any, displayRelationships: any) {
    this.relationships.push(new ControllerRelationshipView(relationshipName, returnFieldValues, returnAvailableValues, displayFields, displayRelationships));
  }
}
